import { render, staticRenderFns } from "./BindAgentToRolesModal.vue?vue&type=template&id=0967bb0e&scoped=true&"
import script from "./BindAgentToRolesModal.vue?vue&type=script&lang=js&"
export * from "./BindAgentToRolesModal.vue?vue&type=script&lang=js&"
import style0 from "./BindAgentToRolesModal.vue?vue&type=style&index=0&id=0967bb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0967bb0e",
  null
  
)

export default component.exports